var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultationRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "consultation-request_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".consultation-request_svg__st2{fill:#f9af17}.consultation-request_svg__st3{fill:#35a4dd}.consultation-request_svg__st4,.consultation-request_svg__st5{fill:none;stroke:#35a4dd;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.consultation-request_svg__st5{stroke:#f9af17}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.6 35v186"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.7 108.8c-2.5-3.4-5.6-6.3-9.2-8.5 3.4 2.5 6.5 5.4 9.2 8.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M943.8 128c0 18 14.6 32.6 32.6 32.6S1009 146 1009 128c0-7.2-2.3-13.9-6.3-19.2-2.8-3.1-5.8-5.9-9.2-8.5-5-3.1-10.9-4.9-17.2-4.9-17.9 0-32.5 14.6-32.5 32.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M882.1 86.8c-1.2 0-2.4.1-3.6.2h7.2c-1.2-.1-2.4-.2-3.6-.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M775.2 35v186M49.5 374.4h926.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.2 218.8c-1.8-16.3-15.6-29-32.4-29-18 0-32.6 14.6-32.6 32.6V952H69.6V152h812.5c18 0 32.6-14.6 32.6-32.6 0-16.8-12.7-30.6-29-32.4H69.6c-35.9 0-65 29.1-65 65v800c0 35.9 29.1 65 65 65h884.6c35.9 0 65-29.1 65-65V226c.1-1.2.2-2.4.2-3.6s-.1-2.4-.2-3.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512 543.7v265.2M644.6 676.3H379.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationRequest);
export default ForwardRef;